enum EventID {
    /**
     * 不能选
     */
    NotSelect = -1,
    /**
     * 添加项
     */
    AddItem = 0,

    /**
     * 显示文章
     */
    Text = 100,
    /**
     * 剧情分歧
     */
    TextDif = 101,
    /**
     * 剧情分歧EX
     */
    TextDifEx = 1010,
    /**
     * 剧情分歧EX2
     */
    TextDifEx2 = 1011,
    /**
     * 剧情分歧结束
     */
    TextEnd = 102,
    /**
     * 自动播放
     */
    AutoPlay = 103,
    /**
     * 快进
     */
    QuickPlay = 104,
    /**
     * 数值输入
     */
    ValueInput = 105,
    /**
     * 提示消息框
     */
    PromptMessage = 106,
    /**
     * 注释
     */
    Comment = 107,
    /**
     * 分支选项内容
     */
    TextChoice = 108,
    /**
     * 消失对话框
     */
    DisposeText = 109,
    /**
     * 打开指定网页
     */
    OpenUrl = 110,
    /**
     * 禁用开启菜单功能
     */
    DisableMenu = 111,
    /**
     * 悬浮组件开关
     */
    FloatControl = 112,
    /**
     * 刷新UI画面
     */
    FreshUI = 150,
    /**
     * 关闭界面
     */
    ReturnGameUI = 151,
    /**
     * 条件分歧
     */
    IF = 200,
    /**
     * 条件分歧结束
     */
    IFEnd = 201,
    /**
     * 循环
     */
    Loop = 202,
    /**
     * 以上反复
     */
    LoopAboveStart = 203,
    /**
     * 按钮分歧
     */
    ButtonDif = 204,
    /**
     * 按钮分歧结束
     */
    ButtonDifEnd = 205,
    /**
     * 跳转剧情
     */
    JumpStory = 206,
    /**
     * 高级UI跳转剧情
     */
    JumpStoryUI = 2063,
    /**
     * 数值操作
     */
    Var = 207,
    /**
     * 返回标题画面
     */
    BackTitle = 208,
    /**
     * 中断循环
     */
    LoopBreak = 209,
    /**
     * 等待
     */
    Wait = 210,
    /**
     * 除此之外的场合
     */
    IfChoice = 211,
    /**
     * 图片分歧选项
     */
    ButtonDifChoose = 212,
    /**
     * 二周目变量
     */
    VarsEx = 213,
    /**
     * 打开界面
     */
    CallMenu = 214,
    /**
     * 字符串
     */
    String = 215,
    /**
     * 高级数值操作
     */
    SeniorVar = 216,
    /**
     * 高级条件分歧
     */
    SeniorIf = 217,
    /**
     * 强制存读档
     */
    ForcedSaveRead = 218,
    /**
     * 生命线效果
     */
    Bubble = 219,
    /**
     * 显示广告
     */
    Ad = 230,
    /**
     * 广告分支
     */
    AdChoice = 231,
    /**
     * 广告结束
     */
    AdEnd = 232,
    /**
     * 呼叫子剧情
     */
    CallSubStory = 251,
    /**
     * 天气
     */
    Weather = 301,
    /**
     * 震动
     */
    Shake = 302,
    /**
     * 画面闪烁
     */
    Flash = 303,
    /**
     * 准备转场
     */
    PlanConvertScene = 304,
    /**
     * 转场开始
     */
    ConvertSceneStart = 305,
    /**
     * 更改场景色调
     */
    UpateSceneHue = 306,
    /**
     * 插入BGM鉴赏
     */
    BGMAdd = 307,
    /**
     * 插入到CG鉴赏
     */
    CGAdd = 308,
    /**
     * 解锁收集项
     */
    UnlockCollect = 309,
    /**
     * 简易特效
     */
    SimpleEffect = 310,
    /**
     * 显示图片
     */
    PicShow = 400,
    /**
     * 图片消失(淡出图片)
     */
    DisposePic = 401,
    /**
     * 移动图片
     */
    MovePic = 402,
    /**
     * 显示心情
     */
    MoodShow = 403,
    /**
     * 旋转图片
     */
    RotatePic = 404,
    /**
     * 资源预加载(仅web用)
     */
    ResourceLoad = 405,
    /**
     * 显示动态图片
     */
    GifPicShow = 406,
    /**
     * 图片遮罩
     */
    MaskPic = 407,
    /**
     * 换装角色
     */
    DressRole = 408,
    /**
     * 播放背景音乐
     */
    StartBGM = 501,
    /**
     * 播放音效
     */
    StartSE = 502,
    /**
     * 播放语音
     */
    StartVoice = 503,
    /**
     * 播放循环音效
     */
    StartBGS = 504,
    /**
     * 淡出背景音乐
     */
    FadeBGM = 505,
    /**
     * 停止音效
     */
    StopSE = 506,
    /**
     * 停止语音
     */
    StopVoice = 507,
    /**
     * 淡出循环音效
     */
    FadeBGS = 508,
    /// 播放视频
    /// </summary>
    MediaPlayAdd = 602,
    /**
     * 视频节点
     */
    MediaPlayNode = 603,
    /**
     * 视频播放完成
     */
    MediaPlayEnd = 604,
    /**
     * 视频选项
     */
    DifMediaPlay = 605,
    /**
     * 视频选项内容
     */
    DifMediaPlayContent = 606,
    /**
     * 视频选项结束
     */
    DifMediaPlayEnd = 607,
    /**
     * 显示视频
     */
    VideoShow = 700,
    /**
     * 体力锁
     */
    VitLock = 252,
    /**
     * 剧情锁
     */
    StoryLock = 253,
    /**
     * 气泡模式
     */
    AirBubbleMode = 220,
    /**
     * 发射气泡
     */
    SendAirBubble = 221,
    /**
     * 动图2.0  4062
     */
    Oaf2 = 4062,
    /**
     * 书签
     */
    BookMark = 701,

    /**
     * 呼叫Scene
     */
    CallScene = 260,

    /**
     * 实例操作
     */
    Obj = 222,

    /**
     * 实例操作
     */
    Array = 223,

    /**
     * 实例元素操作
     */
    ArrayElement = 2231,
}

export default EventID
